import React from 'react';
import styles from './ThumbnailExhibitor.module.scss';

interface iThumbnailExhibitor {
  id: string;
  logo: string | null | undefined;
  nom_societe: string;
  hall: string;
  stand: string;
  showroom: boolean;
  showroom_logo?: string | null | undefined;
  slug?: string;
}

export default function ThumbnailExhibitor({
  id,
  logo,
  nom_societe,
  hall,
  stand,
  showroom = false,
  showroom_logo,
  slug,
}: iThumbnailExhibitor): JSX.Element {
  const BASE_PATH = window.location.pathname.split('/')[1];
  return (
    <div className={styles.ThumbnailExhibitor}>
      <a
        href={`/${BASE_PATH}/preview/events/${slug ?? ''}/exhibitors/${id}`}
        className={styles.ThumbnailExhibitor__link}
      >
        {showroom && showroom_logo && (
          <div
            style={{
              marginTop: '15px',
              position: 'absolute',
              top: '0',
              left: '15px',
              zIndex: 1,
            }}
          >
            <img
              src={showroom_logo}
              alt=""
              width={50}
              height={280}
              className={styles.ThumbnailExhibitor__logo__img}
            />
          </div>
        )}
        <div className={styles.ThumbnailExhibitor__logo}>
          {logo && (
            <img
              src={logo}
              alt=""
              width={150}
              height={280}
              className={styles.ThumbnailExhibitor__logo__img}
            />
          )}
        </div>
        <div className={styles.ThumbnailExhibitor__content}>
          <div>
            <div className={styles.ThumbnailExhibitor__content__title}>
              {nom_societe}
            </div>
          </div>
        </div>
      </a>
      {hall && stand && (
        <a
          href={`/floormap#${hall}${stand}`}
          className={styles.ThumbnailExhibitor__content__booth}
        >
          <span>
            Hall <b>{hall}</b> Booth{' '}
            <b>
              {hall}
              {stand}
            </b>
          </span>
        </a>
      )}
    </div>
  );
}
